import {
  ActionIcon,
  Box,
  Menu,
  Text,
  Tooltip,
  createStyles,
} from "@mantine/core";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import swal from "sweetalert";
import { removeNote } from "../../services/note";
import {
  formatDate,
  formatTime,
  getOptions,
  noteType_Client,
} from "../../utils";
import moment from "moment";
import { getAllFacilitiesModal } from "../../services";
import MenuDropdown from "./MenuDropdown";
import { TimeInput } from "@mantine/dates";
import { BiDotsVerticalRounded } from "react-icons/bi";

const useStyles = createStyles((theme) => ({
  cell: {
    background: "#F0F0F0",
    borderRadius: 5,
    padding: 5,
    fontSize: 14,
    display: "flex",
    alignItems: "center",
    gap: 20,
  },
  parametersContainer: {
    background: "#F0F0F0",
    borderRadius: 5,
    padding: 5,
    width: 50,
    color: "#A8A8A8",
    fontSize: 14,
  },
  bg1: {
    "& td": {
      background: "#fff",
    },
    cursor: "pointer",
  },
  bg2: {
    "& td": {
      background: "#F9FAFB",
    },
    cursor: "pointer",
  },
}));

const NoteTableRow = ({
  row,
  index,
  open,
  openViewModal,
  setView,
  userId,
  sortField,
  sortOrder,
}) => {
  const { profile } = useSelector((state) => state.profile);
  const { allStaff } = useSelector((state) => state.staff);
  const { allFacilities } = useSelector((state) => state?.facility);
  const [rowValues, setRowValues] = useState({});
  const { classes } = useStyles();
  const getFields = () => {
    const fields = {};
    row?.noteId?.custom?.forEach((customElement) => {
      if ("options" in customElement) {
        let optName =
          customElement?.options?.toLowerCase() == "staff"
            ? "Staff All"
            : customElement?.options;
        let options = getOptions(optName, row?.noteId?.custom, undefined, true);
        // let options = getOptions(customElement?.options, row?.noteId?.custom);
        let tempFields = Object.entries(row?.fields)?.find(
          (value) =>
            customElement?.field === "Client Name"
              ? value?.[0]?.["Patient Name"] && !value?.[0]?.["Client Name"]
                ? value?.[0] === "Patient Name"
                : value?.[0]?.["Patient Name"] && value?.[0]?.["Client Name"]
                ? value?.[0] === "Client Name"
                : value?.[0] === "Patient Name" || value?.[0] === "Client Name"
              : value?.[0] === customElement?.field
          // ||
          // value?.[0] === "Client Name"
        );

        let value = options?.find(
          (val) => val?.value === tempFields?.[1]
        )?.label;
        fields[tempFields?.[0]] = value;
      } else {
        if (
          row?.noteId?.name === "Progress Note" &&
          row?.supportPlan === "yes"
        ) {
          fields["_outcomes"] = row.descriptions;
        } else if (
          row?.noteId?.name === "Essential Support Note" &&
          (row?.essentialSupportToggle === "yes" || true)
        ) {
          fields["_outcomes"] = row.essentialSupport;
        } else if (
          row?.noteId?.name === "Intervention Progress Note" &&
          (row?.interventionPlanToggle === "yes" || true)
        ) {
          fields["_outcomes"] = row.goals;
        }
        let tempFields = Object.entries(row?.fields)?.find(
          (value) => value?.[0] === customElement?.field
        );
        if (tempFields?.[0] !== undefined)
          fields[tempFields?.[0]] = tempFields?.[1];
      }
    });

    const obj = {};
    Object.entries(fields)?.map((v) => {
      if (v?.[0] !== undefined || null) {
        obj[v[0]] = v?.[1] || "-";
      }
    });
    // ✅ Add note type here
    obj["_noteType"] = row?.noteId?.name || "-";
    obj["_isInterventionPlan"] = row?.interventionPlanToggle || "-";
    setRowValues(obj);
    return Object.entries(fields);
  };
  useEffect(() => {
    getFields();
  }, [row, allStaff]);

  // functions
  const remove = async (canDelete) => {
    const willDelete = await swal({
      title: `Are you sure?`,
      text: "This action cannot be undone.",
      icon: "warning",
      dangerMode: true,
      buttons: ["Cancel", "Delete"],
    });

    if (willDelete) removeNote(row, userId, () => {}, sortField, sortOrder);
  };

  function handleRowClick(event) {
    setView(true);
    openViewModal(row);
  }
  const Parameters = ({ parameters }) => {
    if (parameters?.length > 1)
      return (
        <Text className={classes.cell}>
          {`${
            parameters?.[0]?.description?.length > 50
              ? `${parameters?.[0]?.description?.slice(0, 50)}...`
              : parameters?.[0]?.description
          }`}
          <Box className={classes.parametersContainer}>
            + {parameters?.length - 1}
          </Box>
        </Text>
      );

    return (
      <Text className={classes.cell}>
        {`${
          parameters?.[0]?.description
            ? parameters[0].description.length > 50
              ? `${parameters[0].description.slice(0, 50)}...`
              : parameters[0].description
            : "-"
        }`}
      </Text>
    );
  };

  const InterventionParameters = ({ parameters }) => {
    const truncate = (text) =>
      text?.length > 50 ? `${text.slice(0, 50)}...` : text;

    const mappedParams = [
      { label: "Behavior", value: parameters?.[0]?.behaviorDescription },
      { label: "Plan", value: parameters?.[0]?.planDescription },
      { label: "Response", value: parameters?.[0]?.responseDescription },
    ].filter((item) => item.value);

    // 👉 case when more than 1 parameter object exists
    if (parameters?.length > 1) {
      return (
        <Text className={classes.cell} style={{ display: "flex", gap: 8 }}>
          {mappedParams.length > 0 ? (
            mappedParams.map((p, idx) => (
              <Text key={idx} style={{ fontSize: 14 }}>
                <strong>{p.label}:</strong> {truncate(p.value)}
              </Text>
            ))
          ) : (
            <Text>-</Text>
          )}
          <Box className={classes.parametersContainer}>
            + {parameters.length - 1}
          </Box>
        </Text>
      );
    }

    // 👉 case when only 1 parameter object exists
    return (
      <div
        className={classes.cell}
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 4,
          alignItems: "flex-start",
        }}
      >
        {mappedParams.length > 0 ? (
          mappedParams.map((p, idx) => (
            <Text key={idx} style={{ fontSize: 14 }}>
              <strong>{p.label}:</strong> {truncate(p.value)}
            </Text>
          ))
        ) : (
          <Text>-</Text>
        )}
      </div>
    );
  };

  const bg = index % 2 === 0;


  return (
    <>
      <tr
        style={{ cursor: "pointer" }}
        className={bg ? classes.bg2 : classes.bg1}
        key={index}
      >
        <td onClick={handleRowClick} style={{ textTransform: "uppercase" }}>
          {row?.id?.slice(-6)}
        </td>
        <td onClick={handleRowClick}>{row?.noteId?.name}</td>
        <td onClick={handleRowClick}>{rowValues?.["Staff Name"] || "-"}</td>
        <td onClick={handleRowClick}>
          {rowValues?.["Date"]
            ? moment(rowValues["Date"]).isValid()
              ? moment(rowValues["Date"]).format("MM-DD-YYYY")
              : rowValues["Date"]
            : "-"}
        </td>

        <td onClick={handleRowClick}>
          {rowValues?.["Time"]
            ? moment(rowValues["Time"], "HH:mm:ss").format("hh:mm:ss a")
            : "-"}
        </td>
        <td onClick={handleRowClick}>{rowValues?.["Facility Name"] || "-"}</td>
        <td onClick={handleRowClick}>
          {rowValues?.[noteType_Client] || rowValues?.["Patient Name"] || "-"}
        </td>
        <td onClick={handleRowClick}>
          {rowValues?._noteType === "Intervention Progress Note" ? (
            <>
              {rowValues?._isInterventionPlan === "yes" ? (
                <InterventionParameters parameters={rowValues["_outcomes"]} />
              ) : rowValues?.["Description"] ? (
                <Tooltip
                  w={300}
                  multiline
                  withArrow
                  label={rowValues?.["Description"]}
                >
                  <span>
                    {rowValues?.["Description"]?.length > 50
                      ? `${rowValues?.["Description"]?.slice(0, 140)}...`
                      : rowValues?.["Description"]}
                  </span>
                </Tooltip>
              ) : (
                "-"
              )}
            </>
          ) : rowValues?._noteType !== "Intervention Progress Note" ? (
            //  <Parameters parameters={rowValues["_outcomes"]} />
            rowValues?.["Description"] &&
            rowValues?.["Description"].trim() !== "" &&
            rowValues["Description"].trim() !== "-" ? (
              `${rowValues["Description"].slice(0, 140)}...`
            ) : (
              <Parameters parameters={rowValues["_outcomes"]} />
            )
          ) : rowValues?.["Description"] ? (
            <Tooltip
              w={300}
              multiline
              withArrow
              label={rowValues?.["Description"]}
            >
              <span>
                {rowValues?.["Description"]?.length > 50
                  ? `${rowValues?.["Description"]?.slice(0, 140)}...`
                  : rowValues?.["Description"]}
              </span>
            </Tooltip>
          ) : (
            "-"
          )}

          {/* {rowValues?._noteType === "Intervention Progress Note" ? ((
            <InterventionParameters parameters={rowValues["_outcomes"]} />
          ) : rowValues?.["Description"] ? (
            <Tooltip
              w={300}
              multiline
              withArrow
              label={`${rowValues?.["Description"]}`}
            >
              <span>
                {rowValues?.["Description"]?.length > 50
                  ? `${rowValues?.["Description"]?.slice(0, 140)}...`
                  : rowValues?.["Description"]}
              </span>
            </Tooltip>
          ) : (
            "-"
          )

          ) : (
            <Parameters parameters={rowValues["_outcomes"]} />
          ) : rowValues?.["Description"] ? (
            <Tooltip
              w={300}
              multiline
              withArrow
              label={`${rowValues?.["Description"]}`}
            >
              <span>
                {rowValues?.["Description"]?.length > 50
                  ? `${rowValues?.["Description"]?.slice(0, 140)}...`
                  : rowValues?.["Description"]}
              </span>
            </Tooltip>
          ) : (
            "-"
          ) } */}
          {/* {rowValues?._outcomes ? (
            <Parameters parameters={rowValues["_outcomes"]} />
          ) : rowValues?.["Description"] ? (
            <Tooltip
              w={300}
              multiline
              withArrow
              label={`${rowValues?.["Description"]}`}
            >
              <span>
                {rowValues?.["Description"]?.length > 50
                  ? `${rowValues?.["Description"]?.slice(0, 140)}...`
                  : rowValues?.["Description"]}
              </span>
            </Tooltip>
          ) : (
            "-"
          )} */}
        </td>
        <td>
          <Menu shadow="md" position="bottom-end" withinPortal zIndex={"1500"}>
            <Menu.Target>
              <ActionIcon>
                <BiDotsVerticalRounded
                  id="vertical-dots"
                  size={20}
                  color="#000"
                />
              </ActionIcon>
            </Menu.Target>
            <Menu.Dropdown>
              <Menu.Item
                onClick={() => {
                  setView(true);
                  openViewModal(row);
                  getAllFacilitiesModal("withDeleted");
                }}
              >
                View
              </Menu.Item>
              <Menu.Item
                // disabled={
                //   profile?.user?.type !== "staff" ||
                //   (profile?.user?.type === "staff" &&
                //     profile?.user?.role === "admin") ||
                //   row?.fields?.["Staff Name"] === profile?.user?.id
                //     ? false
                //     : true
                // }
                // disabled={(() => {
                //   const createdAtDate = new Date(row?.createdAt);
                //   const now = new Date();

                //   const isSameDay =
                //     createdAtDate.getUTCFullYear() === now.getUTCFullYear() &&
                //     createdAtDate.getUTCMonth() === now.getUTCMonth() &&
                //     createdAtDate.getUTCDate() === now.getUTCDate();

                //   if (isSameDay) {
                //     return false;
                //   }

                //   return !(
                //     profile?.user?.type !== "staff" ||
                //     (profile?.user?.type === "staff" &&
                //       profile?.user?.role === "admin") ||
                //     row?.fields?.["Staff Name"] === profile?.user?.id
                //   );
                // })()}

        disabled={(() => {
                  const createdAtDate = new Date(row?.createdAt);
                  const now = new Date();

                  if (
                    profile?.user?.type !== "staff" ||
                    (profile?.user?.type === "staff" &&
                      profile?.user?.role === "admin")
                  ) {
                    return false;
                  }

                  const isOwnRecord =
                    row?.fields?.["Staff Name"] === profile?.user?.id;
                  if (!isOwnRecord) {
                    return true;
                  }


                  const facilityId = row?.fields?.["Facility Name"];

                  const facility = allFacilities?.facilities?.find(
                    (f) => f?._id === facilityId || f?.id === facilityId
                  );

                  const editTimeSetting = facility?.staffnoteEditTime || "1d";

                  if (editTimeSetting === "forever") {
                    return false;
                  }

                  const allowedHours = editTimeSetting === "3d" ? 72 : 24;

                  const diffMs = now - createdAtDate;
                  const diffHours = diffMs / (1000 * 60 * 60);

                  return diffHours > allowedHours;
                })()}
                
                onClick={() => {
                  open(row);
                  getAllFacilitiesModal("withDeleted");
                }}

        
              >
                Edit
              </Menu.Item>
              <Menu.Item
                onClick={() => remove(row?.canDelete)}
                // disabled={
                //   profile?.user?.type !== "staff" ||
                //   (profile?.user?.type === "staff" &&
                //     profile?.user?.role === "admin") ||
                //   row?.fields?.["Staff Name"] === profile?.user?.id
                //     ? false
                //     : true
                // }
                // disabled={(() => {
                //   const createdAtDate = new Date(row?.createdAt);
                //   const now = new Date();

                //   const isSameDay =
                //     createdAtDate.getUTCFullYear() === now.getUTCFullYear() &&
                //     createdAtDate.getUTCMonth() === now.getUTCMonth() &&
                //     createdAtDate.getUTCDate() === now.getUTCDate();

                //   if (isSameDay) {
                //     return false;
                //   }

                //   return !(
                //     profile?.user?.type !== "staff" ||
                //     (profile?.user?.type === "staff" &&
                //       profile?.user?.role === "admin") ||
                //     row?.fields?.["Staff Name"] === profile?.user?.id
                //   );
                // })()}
                disabled={(() => {
                  const createdAtDate = new Date(row?.createdAt);
                  const now = new Date();

                  if (
                    profile?.user?.type !== "staff" ||
                    (profile?.user?.type === "staff" &&
                      profile?.user?.role === "admin")
                  ) {
                    return false;
                  }

                  const isOwnRecord =
                    row?.fields?.["Staff Name"] === profile?.user?.id;
                  if (!isOwnRecord) {
                    return true;
                  }

                  const facilityId = row?.fields?.["Facility Name"];

                  const facility = allFacilities?.facilities?.find(
                    (f) => f?._id === facilityId || f?.id === facilityId
                  );

                  const editTimeSetting = facility?.staffnoteEditTime || "1d";

                  if (editTimeSetting === "forever") {
                    return false;
                  }

                  const allowedHours = editTimeSetting === "3d" ? 72 : 24;

                  const diffMs = now - createdAtDate;
                  const diffHours = diffMs / (1000 * 60 * 60);

                  return diffHours > allowedHours;
                })()}
              >
                Delete
              </Menu.Item>
            </Menu.Dropdown>
          </Menu>
        </td>
      </tr>
    </>
  );
};

const NoteTableRowDashboard = ({ row, index, open, setView }) => {
  const { classes } = useStyles();
  const { allPatients } = useSelector((state) => state?.patient);
  const { allFacilities } = useSelector((state) => state?.facility);
  const { staff } = useSelector((state) => state?.staff);

  const [rowValues, setRowValues] = useState({});

  const getFields = () => {
    const fields = {};
    row?.noteId?.custom?.forEach((customElement) => {
      if ("options" in customElement) {
        let options = getOptions(customElement?.options, row?.noteId?.custom);
        let tempFields = Object.entries(row?.fields)?.find(
          (value) => value?.[0] === customElement?.field
        );

        let value = options?.find(
          (val) => val?.value === tempFields?.[1]
        )?.label;
        fields[tempFields?.[0]] = value;
      } else {
        if (
          row?.noteId?.name === "Progress Note" &&
          row?.supportPlan === "yes"
        ) {
          fields["_outcomes"] = row.descriptions;
        } else if (
          row?.noteId?.name === "Essential Support Note" &&
          (row?.essentialSupportToggle === "yes" || true)
        ) {
          fields["_outcomes"] = row.essentialSupport;
        } else if (
          row?.noteId?.name === "Intervention Progress Note" &&
          (row?.interventionPlanToggle === "yes" || true)
        ) {
          fields["_outcomes"] = row.goals;
        }
        let tempFields = Object.entries(row?.fields)?.find(
          (value) => value?.[0] === customElement?.field
        );
        if (tempFields?.[0] !== undefined)
          fields[tempFields?.[0]] = tempFields?.[1];
      }
    });

    const obj = {};
    Object.entries(fields)?.map((v) => {
      if (v?.[0] !== undefined || null) {
        obj[v[0]] = v?.[1] || "-";
      }
    });
    obj["_noteType"] = row?.noteId?.name || "-";
    obj["_isInterventionPlan"] = row?.interventionPlanToggle || "-";
    setRowValues(obj);
    return Object.entries(fields);
  };
  function handleRowClick(event) {
    setView(true);
    open(row);
  }
  useEffect(() => {
    getFields();
  }, [row, allPatients, allFacilities?.facilities, staff?.staffs]);

  // const Parameters = ({ parameters }) => {
  //   if (parameters?.length > 1)
  //     return (
  //       <Text
  //         className={classes.cell}
  //         style={{ display: "flex", alignItems: "center", gap: 20 }}
  //       >
  //         {`${
  //           parameters?.[0]?.description?.length > 15
  //             ? `${parameters?.[0]?.description?.slice(0, 15)}...`
  //             : parameters?.[0]?.description
  //         }`}
  //         <div
  //           style={{
  //             background: "#F0F0F0",
  //             borderRadius: 5,
  //             padding: 5,
  //             width: 50,
  //             color: "#A8A8A8",
  //             fontSize: 14,
  //           }}
  //         >
  //           + {parameters?.length - 1}
  //         </div>
  //       </Text>
  //     );

  //   return (
  //     <Text className={classes.cell}>
  //       {`${
  //         parameters?.[0]?.description?.length > 15
  //           ? `${parameters?.[0]?.description?.slice(0, 15)}...`
  //           : parameters?.[0]?.description
  //       }`}
  //     </Text>
  //   );
  // };
  const Parameters = ({ parameters }) => {
    if (parameters?.length > 1)
      return (
        <Text className={classes.cell}>
          {`${
            parameters?.[0]?.description?.length > 50
              ? `${parameters?.[0]?.description?.slice(0, 50)}...`
              : parameters?.[0]?.description
          }`}
          <Box className={classes.parametersContainer}>
            + {parameters?.length - 1}
          </Box>
        </Text>
      );

    return (
      <Text className={classes.cell}>
        {`${
          parameters?.[0]?.description
            ? parameters[0].description.length > 50
              ? `${parameters[0].description.slice(0, 50)}...`
              : parameters[0].description
            : "-"
        }`}
      </Text>
    );
  };
  const InterventionParameters = ({ parameters }) => {
    const truncate = (text) =>
      text?.length > 50 ? `${text.slice(0, 50)}...` : text;

    const mappedParams = [
      { label: "Behavior", value: parameters?.[0]?.behaviorDescription },
      { label: "Plan", value: parameters?.[0]?.planDescription },
      { label: "Response", value: parameters?.[0]?.responseDescription },
    ].filter((item) => item.value);

    // 👉 case when more than 1 parameter object exists
    if (parameters?.length > 1) {
      return (
        <Text className={classes.cell} style={{ display: "flex", gap: 8 }}>
          {mappedParams.length > 0 ? (
            mappedParams.map((p, idx) => (
              <Text key={idx} style={{ fontSize: 14 }}>
                <strong>{p.label}:</strong> {truncate(p.value)}
              </Text>
            ))
          ) : (
            <Text>-</Text>
          )}
          <Box className={classes.parametersContainer}>
            + {parameters.length - 1}
          </Box>
        </Text>
      );
    }

    // 👉 case when only 1 parameter object exists
    return (
      <div
        className={classes.cell}
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 4,
          alignItems: "flex-start",
        }}
      >
        {mappedParams.length > 0 ? (
          mappedParams.map((p, idx) => (
            <Text key={idx} style={{ fontSize: 14 }}>
              <strong>{p.label}:</strong> {truncate(p.value)}
            </Text>
          ))
        ) : (
          <Text>-</Text>
        )}
      </div>
    );
  };

  const bg = index % 2 === 0;
  return (
    <>
      <tr key={index} className={bg ? classes.bg2 : classes.bg1}>
        <td onClick={handleRowClick}>{row?.noteId?.name}</td>
        <td onClick={handleRowClick}>{rowValues?.["Staff Name"] || "-"}</td>
        <td onClick={handleRowClick}>{rowValues?.[noteType_Client] || "-"}</td>
        <td onClick={handleRowClick}> {rowValues?.["Facility Name"] || "-"}</td>
        <td onClick={handleRowClick}>
          {rowValues?.["Date"]
            ? moment(rowValues["Date"]).isValid()
              ? moment(rowValues["Date"]).format("MM-DD-YYYY")
              : rowValues["Date"]
            : "-"}
        </td>
        <td onClick={handleRowClick}>
          {rowValues?.["Time"] ? (
            <TimeInput
              // readOnly={view}
              key={index}
              size="md"
              variant="unstyled"
              className={classes.fontSizeClass}
              value={formatTime(rowValues?.["Time"])}
            />
          ) : (
            "-"
          )}
        </td>
        <td onClick={handleRowClick}>
          {rowValues?._noteType === "Intervention Progress Note" ? (
            <>
              {rowValues?._isInterventionPlan === "yes" ? (
                <InterventionParameters parameters={rowValues["_outcomes"]} />
              ) : rowValues?.["Description"] ? (
                <Tooltip
                  w={300}
                  multiline
                  withArrow
                  label={rowValues?.["Description"]}
                >
                  <span>
                    {rowValues?.["Description"]?.length > 50
                      ? `${rowValues?.["Description"]?.slice(0, 140)}...`
                      : rowValues?.["Description"]}
                  </span>
                </Tooltip>
              ) : (
                "-"
              )}
            </>
          ) : rowValues?._noteType !== "Intervention Progress Note" ? (
            // <Parameters parameters={rowValues["_outcomes"]} />
            rowValues?.["Description"] &&
            rowValues?.["Description"].trim() !== "" &&
            rowValues["Description"].trim() !== "-" ? (
              `${rowValues["Description"].slice(0, 140)}...`
            ) : (
              <Parameters parameters={rowValues["_outcomes"]} />
            )
          ) : rowValues?.["Description"] ? (
            <Tooltip
              w={300}
              multiline
              withArrow
              label={rowValues?.["Description"]}
            >
              <span>
                {rowValues?.["Description"]?.length > 50
                  ? `${rowValues?.["Description"]?.slice(0, 140)}...`
                  : rowValues?.["Description"]}
              </span>
            </Tooltip>
          ) : (
            "-"
          )}
        </td>

        <td>
          <MenuDropdown
            isNote={true}
            row={row}
            view={handleRowClick}
            isDashboradMode={true}
          />
        </td>
      </tr>
    </>
  );
};

export default NoteTableRow;
export { NoteTableRowDashboard };
